import { css as _css } from "@emotion/core";
import React from 'react';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { SmallCard } from '../small-card';
import * as styles from './horizontal-slide.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var HorizontalSlide = _ref => {
  var _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Property of the Week' : _ref$title,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$noScroll = _ref.noScroll,
    noScroll = _ref$noScroll === void 0 ? false : _ref$noScroll,
    _ref$component = _ref.component,
    InnerComponent = _ref$component === void 0 ? SmallCard : _ref$component;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.horizontalSlide, !noScroll && styles.scroll])
  }, listings.map((listing, index) => ___EmotionJSX(InnerComponent, {
    key: listing.url,
    title: title,
    listing: listing,
    onClick: () => {
      sendEvent('pow-click', {
        slideType: 'horizontal',
        listing,
        index
      });
      _onClick(listing, index);
    }
  })));
};
export { HorizontalSlide };